export const FLAG_GETTING_SALES_SESSION_DEBIT_NOTES =
  'FLAG_GETTING_SALES_SESSION_DEBIT_NOTES';
export const GET_SALES_SESSION_DEBIT_NOTES = 'GET_SALES_SESSION_DEBIT_NOTES';
export const CLEAR_SALES_SESSION_DEBIT_NOTES =
  'CLEAR_SALES_SESSION_DEBIT_NOTES';
